import {
  CarbonProvider,
  TokensWrapper,
  CarbonScopedTokensProvider,
  DelayedLoading,
  GlobalStyles,
  ThemeWithBreakpoints,
} from '@os/ui';
import { ConnectedRouter } from 'connected-react-router';
import React, { memo, Suspense } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { ScreenSizeProvider } from '@os/hooks';
import { Analytics } from '@os/state-management';
import history from '../history';
import reduxStore from '../store';
import Layout from './containers/Layout';
import Routes from './Routes';

function App() {
  const { store, persistor } = reduxStore();

  return (
    <TokensWrapper>
      <CarbonProvider theme={ThemeWithBreakpoints}>
        <GlobalStyles />
        <CarbonScopedTokensProvider>
          <ScreenSizeProvider>
            <Suspense fallback={<DelayedLoading delay={500} />}>
              <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                  {bootstrapped => {
                    if (!bootstrapped) {
                      return null;
                    }

                    return (
                      <ConnectedRouter history={history}>
                        <Analytics
                          googleAnalyticsKey={process.env.REACT_APP_GA_KEY}
                        />
                        <Layout>
                          <>
                            <Routes />
                          </>
                        </Layout>
                      </ConnectedRouter>
                    );
                  }}
                </PersistGate>
              </Provider>
            </Suspense>
          </ScreenSizeProvider>
        </CarbonScopedTokensProvider>
      </CarbonProvider>
    </TokensWrapper>
  );
}

export default memo(App);
